module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"paymentMethods":"Formas de pagamento","creditCard":"Cartão de crédito","boleto":"Boleto","pix":"Pix","in":"em até {installment}x"},"en-US":{"paymentMethods":"Payment methods","creditCard":"Credit card","boleto":"Boleto","pix":"Pix","in":"in {installment}x"}}')
  delete Component.options._Ctor
}
